import React from "react";
import styles from "./ErrorPage.module.css"

const ErrorPage = () => {
  return (
    <div classname={styles.background}>
      <div
        className={styles.messageContainer}
      >

        <h1 className={styles.errorNumber}>404</h1>
        <h2 className={styles.messageTitle}>Página no encontrada</h2>
      </div>
      <h3 className={styles.messageDescription}>La página a la que estás intentando acceder no existe o ha sido eliminada</h3>
        <i
          className={`pi pi-question ${styles.backgroundIcon}`}
        ></i>
    </ div>
  );
};
export default ErrorPage;
